"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var alert_number_indicator_1 = require("./alert-number-indicator");
var sign_out_1 = require("adp-react-icons/lib/fa/sign-out");
var the_bridge_1 = require("adp-react-icons/lib/adp/the-bridge");
var envelope_1 = require("adp-react-icons/lib/fa/envelope");
var calendar_o_1 = require("adp-react-icons/lib/fa/calendar-o");
var comment_o_1 = require("adp-react-icons/lib/fa/comment-o");
var question_1 = require("adp-react-icons/lib/fa/question");
var _1 = require("../util/_");
var Calendar = function () {
    return (React.createElement("div", null,
        React.createElement(calendar_o_1.default, null),
        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('masthead-icon-bar__item__overlay'), style: { marginTop: 7 } }, new Date().getDate())));
};
var Support = function () {
    return (React.createElement("div", null,
        React.createElement(comment_o_1.default, null),
        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('masthead-icon-bar__item__overlay'), style: { fontSize: 14 } },
            React.createElement(question_1.default, null))));
};
function getIcon(category) {
    switch (category) {
        case 'messageCenter':
            return React.createElement(envelope_1.default, null);
        case 'calendar':
            return React.createElement(Calendar, null);
        case 'pracTheBridgeLink':
            return React.createElement(the_bridge_1.default, null);
        case 'supportCenter':
            return React.createElement(Support, null);
        case 'logout':
            return React.createElement(sign_out_1.default, null);
        default:
            return React.createElement(question_1.default, null);
    }
}
exports.MastheadIconBarItem = function (props) {
    var className = props.className, category = props.category, alertNum = props.alertNum, title = props.title, onClick = props.onClick;
    var customProps = _1.omit(props, Object.keys(exports.MastheadIconBarItem.propTypes));
    return (React.createElement("li", __assign({}, customProps, { className: classnames_1.classNames(className, vdl_prefix_1.vdlPrefix('masthead-icon-bar__item')), onClick: onClick, title: title }),
        getIcon(category),
        alertNum ? React.createElement(alert_number_indicator_1.AlertNumberIndicator, { alertNumber: alertNum }) : undefined));
};
exports.MastheadIconBarItem.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    alertNum: PropTypes.number,
    title: PropTypes.string,
    category: PropTypes.oneOf([
        'messageCenter',
        'calendar',
        'pracTheBridgeLink',
        'supportCenter',
        'logout'
    ])
};
exports.MastheadIconBarItem.displayName = 'MastheadIconBarItem';
